import { gql } from "@apollo/client";

export const SEND_SUPPORT_TICKET = gql`
  mutation SendSupportTicket($input: SupportTicketInput!) {
    sendSupportTicket(input: $input)
  }
`;

export const REPORT_BUG = gql`
  mutation ReportBug($input: SupportTicketInput!) {
    reportBug(input: $input)
  }
`;

export const REQUEST_FEATURE = gql`
  mutation RequestFeature($input: SupportTicketInput!) {
    requestFeature(input: $input)
  }
`;

export const REQUEST_INTEGRATION = gql`
  mutation RequestIntegration($input: SupportTicketInput!) {
    requestIntegration(input: $input)
  }
`;

export const DELETE_USER = gql`
  mutation {
    deleteUser {
      success
      message
    }
  }
`;

export const TURN_ON_NOTIFICATIONS = gql`
  mutation TurnOnNotifications($notificationToken: String) {
    turnOnNotifications(notificationToken: $notificationToken) {
      success
      receiveNotification
      receivePushNotification
      receiveEmailNotification
      notificationToken
    }
  }
`;

export const TURN_OFF_NOTIFICATIONS = gql`
  mutation TurnOffNotifications {
    turnOffNotifications {
      success
      receiveNotification
      receivePushNotification
      receiveEmailNotification
      notificationToken
    }
  }
`;

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences($input: UpdateNotificationPreferencesInput!) {
    updateNotificationPreferences(input: $input) {
      success
      receivePushNotification
      receiveEmailNotification
    }
  }
`;

export const MARK_NOTIFICATION_READ = gql`
  mutation MarkNotificationRead($id: ID!) {
    markNotificationRead(id: $id) {
      id
      read
      updatedAt
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_READ = gql`
  mutation MarkAllNotificationsRead {
    markAllNotificationsRead
  }
`;

export const UPDATE_ACTION_STATUS = gql`
  mutation UpdateStatus($userId: ID!, $actionId: ID!) {
    updateStatusinTaskWithActionsToRun(userId: $userId, actionId: $actionId) {
      success
      message
      actionId
      actionStatus
      tasksMatched
      tasksModified
    }
  }
`;

export const UPDATE_TASK_STATUS = gql`
  mutation UpdateTaskStatus($taskId: ID!, $userId: ID, $status: String) {
    updateTaskStatus(taskId: $taskId, userId: $userId, status: $status) {
      success
      message
      task {
        id
        status
        isCompleted
        updatedAt
      }
    }
  }
`;

export const MARK_TASK_AS_IGNORED = gql`
  mutation MarkTaskAsIgnored($taskId: ID!, $userId: ID, $reason: String!) {
    markTaskAsIgnored(taskId: $taskId, userId: $userId, reason: $reason) {
      success
      message
      task {
        id
        status
        isCompleted
        updatedAt
      }
    }
  }
`;

export const UPDATE_USER_TASK_COMPLETED = gql`
  mutation UpdateUserTaskWhenCompleted($taskId: ID!, $userId: ID) {
    updateUserTaskWhenCompleted(taskId: $taskId, userId: $userId) {
      success
      message
      taskId
      actionId
      rollup {
        totalTasks
        completedTasks
        allCompleted
      }
      task {
        id
        status
        isCompleted
        updatedAt
      }
    }
  }
`;

export const RUN_ALL_TASKS = gql`
  mutation RunAllTasks($userId: ID) {
    runAllTasks(userId: $userId) {
      success
      message
      total
      queued
      failed
      taskIds
      errors
    }
  }
`;

export const RUN_ALL_TASKS_BY_PRODUCT_ID = gql`
  mutation RunAllTasksByProductId($userId: ID, $productId: ID!) {
    runAllTasksByProductId(userId: $userId, productId: $productId) {
      success
      message
      total
      queued
      failed
      taskIds
      errors
    }
  }
`;

export const RUN_ALL_TASKS_BY_ARTICLE_ID = gql`
  mutation RunAllTasksByArticleId($userId: ID, $articleId: ID!) {
    runAllTasksByArticleId(userId: $userId, articleId: $articleId) {
      success
      message
      total
      queued
      failed
      taskIds
      errors
    }
  }
`;

export const DISCONNECT_GOOGLE = gql`
  mutation DisconnectGoogle {
    disconnectGoogle {
      success
      message
    }
  }
`;

export const DISCONNECT_META = gql`
  mutation DisconnectMeta {
    disconnectMeta {
      success
      message
    }
  }
`;

export const DISCONNECT_TIKTOK = gql`
  mutation DisconnectTikTok {
    disconnectTikTok {
      success
      message
    }
  }
`;
